
import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-user-line',
      title: 'Initial Consultation & Buyer Interview',
      description: 'One-on-one business consultation with a Certified Business Broker',
      details: [
        'Personalized assessment of your business goals',
        'Industry interests evaluation',
        'Acquisition budget analysis',
        'Guidance on structuring search criteria'
      ],
      image: 'https://public.readdy.ai/ai/img_res/2f1afd6f59d179dded7a6be1786475ad.jpg'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Feasibility & Financial Assessment',
      description: 'Expert evaluation of business purchase feasibility within your budget',
      details: [
        'Evaluation of purchase feasibility',
        'Expert analysis of key financial metrics',
        'Seller\'s Discretionary Earnings (SDE) review',
        'Financial statement education and red flag identification'
      ],
      image: 'https://readdy.ai/api/search-image?query=Financial%20analysis%20and%20business%20valuation%20documents%20with%20calculator%2C%20charts%2C%20graphs%2C%20and%20financial%20statements%20on%20desk%2C%20professional%20business%20assessment%20environment%2C%20clean%20modern%20office%20setting&width=400&height=300&seq=service-002&orientation=landscape'
    },
    {
      icon: 'ri-search-line',
      title: 'Targeted Business Search',
      description: 'Customized search and presentation of qualified business opportunities',
      details: [
        'Cash flowing businesses within your requested area',
        'Access to both on-market and off-market opportunities',
        'Comprehensive business summaries',
        'Guidance on potential opportunities'
      ],
      image: 'https://readdy.ai/api/search-image?query=Business%20search%20and%20opportunity%20analysis%20with%20multiple%20business%20listings%2C%20market%20research%20documents%2C%20location%20maps%2C%20and%20opportunity%20assessments%20spread%20on%20professional%20desk%2C%20organized%20presentation&width=400&height=300&seq=service-003&orientation=landscape'
    },
    {
      icon: 'ri-bank-line',
      title: 'SBA Loan Guidance & Approval Support',
      description: 'Complete SBA financing assistance with certified underwriter support',
      details: [
        'Full eligibility and approval assessment',
        'Step-by-step SBA forms assistance',
        'Lender application support',
        'Access to Certified SBA Loan Underwriter'
      ],
      image: 'https://readdy.ai/api/search-image?query=SBA%20loan%20application%20process%20with%20official%20documents%2C%20bank%20meeting%2C%20loan%20approval%20paperwork%2C%20and%20financial%20planning%20materials%20in%20professional%20banking%20environment%2C%20success%20oriented%20atmosphere&width=400&height=300&seq=service-004&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'SBA Pre-Approval & Proof of Funds',
      description: 'Strategic advantage through pre-approval and proven purchase power',
      details: [
        'Assistance in securing SBA Pre-Approval Letter',
        'Proof of funds documentation',
        'Present yourself as a serious, educated buyer',
        'Strategic advantage in negotiations'
      ],
      image: 'https://readdy.ai/api/search-image?query=SBA%20pre-approval%20letter%20and%20proof%20of%20funds%20documents%20with%20official%20stamps%20and%20signatures%2C%20professional%20business%20financing%20paperwork%2C%20success%20and%20approval%20theme%2C%20clean%20office%20environment&width=400&height=300&seq=service-005&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Core Services Included in Every Program
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you choose Premium or Elite, you'll receive comprehensive support from certified professionals throughout your business acquisition journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-64 md:h-full object-cover object-top"
                  />
                </div>
                <div className="md:w-2/3 p-8">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mr-4">
                      <i className={`${service.icon} text-white text-xl`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                  </div>
                  
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  
                  <ul className="space-y-2">
                    {service.details.map((detail, detailIndex) => (
                      <li key={detailIndex} className="flex items-start">
                        <i className="ri-check-line text-teal-500 mr-2 mt-1 flex-shrink-0"></i>
                        <span className="text-gray-700 text-sm">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-teal-500 text-white p-8 rounded-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">Investment in Your Success</h3>
            <p className="text-lg">
              All of the above services are provided in a comprehensive package designed to maximize your chances of a successful business acquisition.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
